module.exports = __webpack_public_path__ + "img/FullSail-logo.45cbf542.png";